__webpack_require__.p = "https://cdn.jsdelivr.net/gh/terresolide/geodesy-plotter-vjs@1.9.8/dist/";